function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var Decimal = require('decimal.js');
var _require = require('uuid'),
  v4 = _require.v4;
var _require2 = require('@mixin.dev/mixin-node-sdk'),
  MixinApi = _require2.MixinApi,
  getED25519KeyPair = _require2.getED25519KeyPair,
  base64RawURLEncode = _require2.base64RawURLEncode,
  MixinCashier = _require2.MixinCashier,
  buildSafeTransactionRecipient = _require2.buildSafeTransactionRecipient,
  getUnspentOutputsForRecipients = _require2.getUnspentOutputsForRecipients,
  buildSafeTransaction = _require2.buildSafeTransaction,
  encodeSafeTransaction = _require2.encodeSafeTransaction,
  signSafeTransaction = _require2.signSafeTransaction,
  blake3Hash = _require2.blake3Hash;
var MIXIN_APP_KEY_FIELDS = ['app_id', 'session_id', 'server_public_key', 'session_private_key'];
function mixinAppKeystore(value) {
  if (!value || _typeof(value) !== 'object' || Array.isArray(value)) {
    return null;
  }
  var keystore = {};
  var _iterator = _createForOfIteratorHelper(MIXIN_APP_KEY_FIELDS),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var field = _step.value;
      if (typeof value[field] !== 'string' || !value[field].trim()) {
        return null;
      }
      keystore[field] = value[field].trim();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return keystore;
}
function mixinAppKeystoreFromEnv() {
  if (typeof process === 'undefined' || typeof process.env.MIXIN === 'undefined') {
    return null;
  }
  try {
    return mixinAppKeystore(JSON.parse(process.env.MIXIN));
  } catch (err) {
    return null;
  }
}
function _createAppSession(fallback) {
  var keystore = mixinAppKeystoreFromEnv() || mixinAppKeystore(fallback);
  if (!keystore) {
    return null;
  }
  return MixinApi({
    keystore: keystore
  });
}
function createUserSession() {
  var credentials = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var keystore = {
    app_id: credentials.user_id,
    session_id: credentials.session_id,
    pin_token_base64: credentials.tip_key_base64 || credentials.pin_token_base64,
    session_private_key: credentials.session_seed || credentials.session_private_key
  };
  var spendPrivateKey = credentials.spend_private_key;
  var missing = [];
  for (var _i = 0, _Object$entries = Object.entries(_objectSpread(_objectSpread({}, keystore), {}, {
      spend_private_key: spendPrivateKey
    })); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      name = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    if (!value) {
      missing.push(name);
    }
  }
  if (missing.length) {
    throw new Error("Mixin account configuration is incomplete (missing: ".concat(missing.join(', '), ")"));
  }
  return MixinApi({
    keystore: keystore
  });
}
function getWithdrawalFeeQuote(quotes, assetId, chainAssetId) {
  var _ref;
  var list = Array.isArray(quotes) ? quotes : quotes ? [quotes] : [];
  var assetQuote = list.find(function (quote) {
    return quote.asset_id === assetId;
  });
  var chainQuote = list.find(function (quote) {
    return quote.asset_id === chainAssetId;
  });
  return (_ref = assetQuote !== null && assetQuote !== void 0 ? assetQuote : chainQuote) !== null && _ref !== void 0 ? _ref : list.length === 1 ? list[0] : null;
}
function memoBytes() {
  var memo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (Buffer.isBuffer(memo)) {
    return memo;
  }
  return Buffer.from(String(memo), 'utf8');
}
function pendingBalance(balance) {
  var pending = new Decimal(balance);
  for (var _len = arguments.length, deductions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    deductions[_key - 1] = arguments[_key];
  }
  for (var _i2 = 0, _deductions = deductions; _i2 < _deductions.length; _i2++) {
    var deduction = _deductions[_i2];
    pending = pending.minus(deduction);
  }
  return Number(pending.toFixed(8));
}
function formatMixinError(err) {
  var _err$response;
  var apiError = err === null || err === void 0 || (_err$response = err.response) === null || _err$response === void 0 || (_err$response = _err$response.data) === null || _err$response === void 0 ? void 0 : _err$response.error;
  if (apiError !== null && apiError !== void 0 && apiError.description || apiError !== null && apiError !== void 0 && apiError.code) {
    return [apiError.code, apiError.description].filter(Boolean).join(': ');
  }
  if (err instanceof Error) {
    return err.message;
  }
  if (typeof err === 'string') {
    return err;
  }
  try {
    var serialized = JSON.stringify(err);
    return serialized === undefined ? String(err) : serialized;
  } catch (jsonError) {
    return String(err);
  }
}
function snapshotOffset() {
  var createdAt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var offset = new Date(createdAt).toISOString();
  offset = offset.substring(0, offset.length - 1);
  return offset + '000000Z';
}
var Api = /*#__PURE__*/function () {
  function Api() {
    _classCallCheck(this, Api);
    this.appKeystore = null;
  }
  return _createClass(Api, [{
    key: "createAppSession",
    value: function createAppSession() {
      return _createAppSession(this.appKeystore);
    }
  }, {
    key: "createAccount",
    value: function () {
      var _createAccount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(displayName) {
        var appSession, _getED25519KeyPair, sessionSeed, sessionPublicKey, sessionPrivateKey, user, session, _getED25519KeyPair2, spendPublicKey, spendPrivateKey, spendPrivateKeyHex, account;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              appSession = this.createAppSession();
              if (appSession) {
                _context.n = 1;
                break;
              }
              throw new Error('Cannot process Mixin account request for peer');
            case 1:
              _getED25519KeyPair = getED25519KeyPair(), sessionSeed = _getED25519KeyPair.seed, sessionPublicKey = _getED25519KeyPair.publicKey;
              sessionPrivateKey = sessionSeed.toString('hex');
              _context.n = 2;
              return appSession.user.createBareUser(displayName, base64RawURLEncode(sessionPublicKey));
            case 2:
              user = _context.v;
              // This session exists only long enough to set the first spend key.
              // createUserSession requires that key, so it cannot build this session.
              session = MixinApi({
                keystore: {
                  app_id: user.user_id,
                  session_id: user.session_id,
                  pin_token_base64: user.pin_token_base64,
                  session_private_key: sessionPrivateKey
                }
              });
              _getED25519KeyPair2 = getED25519KeyPair(), spendPublicKey = _getED25519KeyPair2.publicKey, spendPrivateKey = _getED25519KeyPair2.seed;
              spendPrivateKeyHex = spendPrivateKey.toString('hex');
              _context.n = 3;
              return session.pin.updateTipPin('', spendPublicKey.toString('hex'), user.tip_counter + 1);
            case 3:
              _context.n = 4;
              return session.pin.verifyTipPin(spendPrivateKey);
            case 4:
              _context.n = 5;
              return session.safe.register(user.user_id, spendPrivateKeyHex, spendPrivateKey);
            case 5:
              account = _context.v;
              return _context.a(2, {
                user_id: account.user_id,
                full_name: account.full_name,
                session_id: account.session_id,
                tip_key_base64: account.tip_key_base64,
                spend_private_key: spendPrivateKeyHex,
                spend_public_key: spendPublicKey.toString('hex'),
                session_seed: sessionPrivateKey,
                backed_up: true
              });
          }
        }, _callee, this);
      }));
      function createAccount(_x) {
        return _createAccount.apply(this, arguments);
      }
      return createAccount;
    }()
  }, {
    key: "createAddress",
    value: function () {
      var _createAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(credentials, chainId) {
        var _created$, session, created, address, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (chainId) {
                _context2.n = 1;
                break;
              }
              console.error('ERROR: Cannot create Mixin deposit address without a chain ID');
              return _context2.a(2, false);
            case 1:
              _context2.p = 1;
              session = createUserSession(credentials);
              _context2.n = 2;
              return session.safe.createDeposit(chainId);
            case 2:
              created = _context2.v;
              address = created === null || created === void 0 || (_created$ = created[0]) === null || _created$ === void 0 ? void 0 : _created$.destination;
              if (address) {
                _context2.n = 3;
                break;
              }
              console.error('ERROR: Mixin error create deposit address: Deposit Address undefined!');
              return _context2.a(2, false);
            case 3:
              console.log('New MIXIN deposit address:', created);
              return _context2.a(2, address);
            case 4:
              _context2.p = 4;
              _t = _context2.v;
              console.error('ERROR: Mixin error create deposit address: ' + formatMixinError(_t));
              return _context2.a(2, false);
          }
        }, _callee2, null, [[1, 4]]);
      }));
      function createAddress(_x2, _x3) {
        return _createAddress.apply(this, arguments);
      }
      return createAddress;
    }()
  }, {
    key: "fetchBalance",
    value: function () {
      var _fetchBalance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(credentials, assetId) {
        var session, _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              session = createUserSession(credentials);
              _context3.n = 1;
              return session.utxo.safeAssetBalance({
                members: [credentials.user_id],
                threshold: 1,
                asset: assetId
              });
            case 1:
              return _context3.a(2, _context3.v);
            case 2:
              _context3.p = 2;
              _t2 = _context3.v;
              console.error('ERROR: Mixin error fetch safe utxo: ' + _t2);
              return _context3.a(2, false);
          }
        }, _callee3, null, [[0, 2]]);
      }));
      function fetchBalance(_x4, _x5) {
        return _fetchBalance.apply(this, arguments);
      }
      return fetchBalance;
    }()
  }, {
    key: "fetchHistory",
    value: function () {
      var _fetchHistory = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(credentials, assetId) {
        var since,
          session,
          _args4 = arguments,
          _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              since = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : 0;
              _context4.p = 1;
              session = createUserSession(credentials);
              _context4.n = 2;
              return session.safe.fetchSafeSnapshots({
                asset: assetId,
                limit: 500,
                offset: snapshotOffset(since)
              });
            case 2:
              return _context4.a(2, _context4.v);
            case 3:
              _context4.p = 3;
              _t3 = _context4.v;
              console.error('ERROR: Mixin error fetch safe snapshots: ' + _t3);
              return _context4.a(2, false);
          }
        }, _callee4, null, [[1, 3]]);
      }));
      function fetchHistory(_x6, _x7) {
        return _fetchHistory.apply(this, arguments);
      }
      return fetchHistory;
    }()
  }, {
    key: "fetchDeposits",
    value: function () {
      var _fetchDeposits = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(credentials, assetId, address) {
        var session, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              if (address) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2, []);
            case 1:
              session = createUserSession(credentials);
              _context5.n = 2;
              return session.safe.pendingDeposits({
                asset: assetId,
                destination: address
              });
            case 2:
              return _context5.a(2, _context5.v);
            case 3:
              _context5.p = 3;
              _t4 = _context5.v;
              console.error('ERROR: Mixin error fetch fetchPendingDeposits: ' + _t4);
              return _context5.a(2, false);
          }
        }, _callee5, null, [[0, 3]]);
      }));
      function fetchDeposits(_x8, _x9, _x0) {
        return _fetchDeposits.apply(this, arguments);
      }
      return fetchDeposits;
    }()
  }, {
    key: "fetchAsset",
    value: function () {
      var _fetchAsset = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(assetId) {
        var session, _t5;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              session = this.createAppSession(); // Missing application session is an expected unconfigured state, not an
              // API failure. Callers treat false as "no asset info".
              if (session) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2, false);
            case 1:
              _context6.p = 1;
              _context6.n = 2;
              return session.network.fetchAsset(assetId);
            case 2:
              return _context6.a(2, _context6.v);
            case 3:
              _context6.p = 3;
              _t5 = _context6.v;
              console.error('ERROR: Mixin error check network fee: ' + formatMixinError(_t5));
              return _context6.a(2, false);
          }
        }, _callee6, this, [[1, 3]]);
      }));
      function fetchAsset(_x1) {
        return _fetchAsset.apply(this, arguments);
      }
      return fetchAsset;
    }()
  }, {
    key: "fetchWithdrawalFee",
    value: function () {
      var _fetchWithdrawalFee = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(credentials, assetId, address) {
        var session, asset, chain, quotes, quote, feeAsset, _t6, _t7, _t8, _t9;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              session = createUserSession(credentials);
              _context7.n = 1;
              return session.safe.fetchAsset(assetId);
            case 1:
              asset = _context7.v;
              if (!(asset.chain_id === asset.asset_id)) {
                _context7.n = 2;
                break;
              }
              _t6 = asset;
              _context7.n = 4;
              break;
            case 2:
              _context7.n = 3;
              return session.safe.fetchAsset(asset.chain_id);
            case 3:
              _t6 = _context7.v;
            case 4:
              chain = _t6;
              _context7.n = 5;
              return session.safe.fetchFee(asset.asset_id, address);
            case 5:
              quotes = _context7.v;
              quote = getWithdrawalFeeQuote(quotes, asset.asset_id, chain.asset_id);
              if (!(!(quote !== null && quote !== void 0 && quote.asset_id) || quote.amount == null)) {
                _context7.n = 6;
                break;
              }
              throw new Error("No withdrawal fee available for ".concat(assetId));
            case 6:
              if (!(quote.asset_id === asset.asset_id)) {
                _context7.n = 7;
                break;
              }
              _t7 = asset;
              _context7.n = 11;
              break;
            case 7:
              if (!(quote.asset_id === chain.asset_id)) {
                _context7.n = 8;
                break;
              }
              _t8 = chain;
              _context7.n = 10;
              break;
            case 8:
              _context7.n = 9;
              return session.safe.fetchAsset(quote.asset_id);
            case 9:
              _t8 = _context7.v;
            case 10:
              _t7 = _t8;
            case 11:
              feeAsset = _t7;
              return _context7.a(2, _objectSpread(_objectSpread({}, quote), {}, {
                amount: quote.amount,
                assetId: quote.asset_id,
                ticker: feeAsset.display_symbol || feeAsset.symbol
              }));
            case 12:
              _context7.p = 12;
              _t9 = _context7.v;
              console.error('ERROR: Mixin error check withdrawl fee: ' + _t9);
              return _context7.a(2, false);
          }
        }, _callee7, null, [[0, 12]]);
      }));
      function fetchWithdrawalFee(_x10, _x11, _x12) {
        return _fetchWithdrawalFee.apply(this, arguments);
      }
      return fetchWithdrawalFee;
    }()
  }, {
    key: "sendToUser",
    value: function () {
      var _sendToUser = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(credentials, assetId, mixinUserId, amount) {
        var _sent$;
        var memo,
          session,
          spendPrivateKey,
          members,
          threshold,
          recipients,
          outputs,
          balance,
          _getUnspentOutputsFor,
          utxos,
          change,
          requestId,
          ghosts,
          tx,
          raw,
          verifiedTx,
          signedRaw,
          sent,
          _args8 = arguments,
          _t0;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              memo = _args8.length > 4 && _args8[4] !== undefined ? _args8[4] : '';
              session = createUserSession(credentials);
              spendPrivateKey = credentials.spend_private_key;
              members = [mixinUserId];
              threshold = 1;
              recipients = [buildSafeTransactionRecipient(members, threshold, amount)];
              _context8.n = 1;
              return session.utxo.safeOutputs({
                members: [credentials.user_id],
                threshold: 1,
                asset: assetId,
                state: 'unspent'
              });
            case 1:
              outputs = _context8.v;
              _context8.n = 2;
              return session.utxo.safeAssetBalance({
                members: [credentials.user_id],
                threshold: 1,
                asset: assetId,
                state: 'unspent'
              });
            case 2:
              balance = _context8.v;
              _getUnspentOutputsFor = getUnspentOutputsForRecipients(outputs, recipients), utxos = _getUnspentOutputsFor.utxos, change = _getUnspentOutputsFor.change;
              if (!change.isZero() && !change.isNegative()) {
                recipients.push(buildSafeTransactionRecipient(outputs[0].receivers, outputs[0].receivers_threshold, change.toString()));
              }
              requestId = v4();
              _context8.n = 3;
              return session.utxo.ghostKey(recipients, requestId, spendPrivateKey);
            case 3:
              ghosts = _context8.v;
              tx = buildSafeTransaction(utxos, recipients, ghosts, memoBytes(memo));
              _context8.p = 4;
              raw = encodeSafeTransaction(tx);
              _context8.n = 6;
              break;
            case 5:
              _context8.p = 5;
              _t0 = _context8.v;
              throw new Error("Unable to encode Mixin Safe transaction (".concat(tx.inputs.length, " input(s), ").concat(tx.outputs.length, " output(s), asset ").concat(tx.asset, "): ").concat(formatMixinError(_t0)));
            case 6:
              _context8.n = 7;
              return session.utxo.verifyTransaction([{
                raw: raw,
                request_id: requestId
              }]);
            case 7:
              verifiedTx = _context8.v;
              signedRaw = signSafeTransaction(tx, verifiedTx[0].views, spendPrivateKey);
              _context8.n = 8;
              return session.utxo.sendTransactions([{
                raw: signedRaw,
                request_id: requestId
              }]);
            case 8:
              sent = _context8.v;
              return _context8.a(2, {
                hash: (sent === null || sent === void 0 || (_sent$ = sent[0]) === null || _sent$ === void 0 ? void 0 : _sent$.transaction_hash) || '',
                pendingBalance: pendingBalance(balance, amount)
              });
          }
        }, _callee8, null, [[4, 5]]);
      }));
      function sendToUser(_x13, _x14, _x15, _x16) {
        return _sendToUser.apply(this, arguments);
      }
      return sendToUser;
    }()
  }, {
    key: "sendToAddress",
    value: function () {
      var _sendToAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(credentials, assetId, address, amount) {
        var _sent$3;
        var memo,
          session,
          spendPrivateKey,
          balance,
          asset,
          chain,
          quotes,
          quote,
          assetTicker,
          feeAsset,
          feeTicker,
          assetRequired,
          _sent$2,
          _outputs,
          feeOutputs,
          feeBalance,
          _recipients,
          _getUnspentOutputsFor2,
          _utxos,
          _change,
          txId,
          _ghosts,
          _tx,
          _raw,
          ref,
          feeRecipients,
          _getUnspentOutputsFor3,
          feeUtxos,
          feeChange,
          feeId,
          feeGhosts,
          feeTx,
          feeRaw,
          _txs,
          _signedRaw,
          signedFeeRaw,
          _sent,
          outputs,
          recipients,
          _getUnspentOutputsFor4,
          utxos,
          change,
          requestId,
          ghosts,
          tx,
          raw,
          txs,
          signedRaw,
          sent,
          _args9 = arguments,
          _t1,
          _t10,
          _t11;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              memo = _args9.length > 4 && _args9[4] !== undefined ? _args9[4] : '';
              session = createUserSession(credentials);
              spendPrivateKey = credentials.spend_private_key;
              _context9.n = 1;
              return session.utxo.safeAssetBalance({
                members: [credentials.user_id],
                threshold: 1,
                asset: assetId,
                state: 'unspent'
              });
            case 1:
              balance = _context9.v;
              _context9.n = 2;
              return session.safe.fetchAsset(assetId);
            case 2:
              asset = _context9.v;
              if (!(asset.chain_id === asset.asset_id)) {
                _context9.n = 3;
                break;
              }
              _t1 = asset;
              _context9.n = 5;
              break;
            case 3:
              _context9.n = 4;
              return session.safe.fetchAsset(asset.chain_id);
            case 4:
              _t1 = _context9.v;
            case 5:
              chain = _t1;
              _context9.n = 6;
              return session.safe.fetchFee(asset.asset_id, address);
            case 6:
              quotes = _context9.v;
              quote = getWithdrawalFeeQuote(quotes, asset.asset_id, chain.asset_id);
              if (!(!(quote !== null && quote !== void 0 && quote.asset_id) || quote.amount == null)) {
                _context9.n = 7;
                break;
              }
              throw new Error("No withdrawal fee available for ".concat(assetId));
            case 7:
              assetTicker = asset.display_symbol || asset.symbol;
              if (!(quote.asset_id === asset.asset_id)) {
                _context9.n = 8;
                break;
              }
              _t10 = asset;
              _context9.n = 12;
              break;
            case 8:
              if (!(quote.asset_id === chain.asset_id)) {
                _context9.n = 9;
                break;
              }
              _t11 = chain;
              _context9.n = 11;
              break;
            case 9:
              _context9.n = 10;
              return session.safe.fetchAsset(quote.asset_id);
            case 10:
              _t11 = _context9.v;
            case 11:
              _t10 = _t11;
            case 12:
              feeAsset = _t10;
              feeTicker = feeAsset.display_symbol || feeAsset.symbol;
              assetRequired = new Decimal(amount).plus(quote.asset_id === asset.asset_id ? quote.amount : 0);
              if (!new Decimal(balance).lessThan(assetRequired)) {
                _context9.n = 13;
                break;
              }
              throw new Error("Insufficient ".concat(assetTicker, " balance: ").concat(assetRequired.toString(), " required, ").concat(balance, " available."));
            case 13:
              if (!(quote.asset_id !== asset.asset_id)) {
                _context9.n = 22;
                break;
              }
              _context9.n = 14;
              return session.utxo.safeOutputs({
                asset: assetId,
                state: 'unspent'
              });
            case 14:
              _outputs = _context9.v;
              _context9.n = 15;
              return session.utxo.safeOutputs({
                asset: quote.asset_id,
                state: 'unspent'
              });
            case 15:
              feeOutputs = _context9.v;
              _context9.n = 16;
              return session.utxo.safeAssetBalance({
                members: [credentials.user_id],
                threshold: 1,
                asset: quote.asset_id,
                state: 'unspent'
              });
            case 16:
              feeBalance = _context9.v;
              if (!new Decimal(feeBalance).lessThan(quote.amount)) {
                _context9.n = 17;
                break;
              }
              throw new Error("A ".concat(feeTicker, " balance is required to withdraw ").concat(assetTicker, ". ") + "The network fee is ".concat(quote.amount, " ").concat(feeTicker, ", but only ").concat(feeBalance, " ").concat(feeTicker, " is available."));
            case 17:
              _recipients = [{
                amount: amount,
                destination: address
              }];
              _getUnspentOutputsFor2 = getUnspentOutputsForRecipients(_outputs, _recipients), _utxos = _getUnspentOutputsFor2.utxos, _change = _getUnspentOutputsFor2.change;
              if (!_change.isZero() && !_change.isNegative()) {
                _recipients.push(buildSafeTransactionRecipient(_outputs[0].receivers, _outputs[0].receivers_threshold, _change.toString()));
              }
              txId = v4();
              _context9.n = 18;
              return session.utxo.ghostKey(_recipients, txId, spendPrivateKey);
            case 18:
              _ghosts = _context9.v;
              _tx = buildSafeTransaction(_utxos, _recipients, _ghosts, memoBytes(memo));
              _raw = encodeSafeTransaction(_tx);
              ref = blake3Hash(Buffer.from(_raw, 'hex')).toString('hex');
              feeRecipients = [buildSafeTransactionRecipient([MixinCashier], 1, quote.amount)];
              _getUnspentOutputsFor3 = getUnspentOutputsForRecipients(feeOutputs, feeRecipients), feeUtxos = _getUnspentOutputsFor3.utxos, feeChange = _getUnspentOutputsFor3.change;
              if (!feeChange.isZero() && !feeChange.isNegative()) {
                feeRecipients.push(buildSafeTransactionRecipient(feeOutputs[0].receivers, feeOutputs[0].receivers_threshold, feeChange.toString()));
              }
              feeId = v4();
              _context9.n = 19;
              return session.utxo.ghostKey(feeRecipients, feeId, spendPrivateKey);
            case 19:
              feeGhosts = _context9.v;
              feeTx = buildSafeTransaction(feeUtxos, feeRecipients, feeGhosts, memoBytes(), [ref]);
              feeRaw = encodeSafeTransaction(feeTx);
              _context9.n = 20;
              return session.utxo.verifyTransaction([{
                raw: _raw,
                request_id: txId
              }, {
                raw: feeRaw,
                request_id: feeId
              }]);
            case 20:
              _txs = _context9.v;
              _signedRaw = signSafeTransaction(_tx, _txs[0].views, spendPrivateKey);
              signedFeeRaw = signSafeTransaction(feeTx, _txs[1].views, spendPrivateKey);
              _context9.n = 21;
              return session.utxo.sendTransactions([{
                raw: _signedRaw,
                request_id: txId
              }, {
                raw: signedFeeRaw,
                request_id: feeId
              }]);
            case 21:
              _sent = _context9.v;
              return _context9.a(2, {
                hash: (_sent === null || _sent === void 0 || (_sent$2 = _sent[0]) === null || _sent$2 === void 0 ? void 0 : _sent$2.transaction_hash) || '',
                pendingBalance: pendingBalance(balance, amount)
              });
            case 22:
              _context9.n = 23;
              return session.utxo.safeOutputs({
                asset: assetId,
                state: 'unspent'
              });
            case 23:
              outputs = _context9.v;
              recipients = [{
                amount: amount,
                destination: address
              }, buildSafeTransactionRecipient([MixinCashier], 1, quote.amount)];
              _getUnspentOutputsFor4 = getUnspentOutputsForRecipients(outputs, recipients), utxos = _getUnspentOutputsFor4.utxos, change = _getUnspentOutputsFor4.change;
              if (!change.isZero() && !change.isNegative()) {
                recipients.push(buildSafeTransactionRecipient(outputs[0].receivers, outputs[0].receivers_threshold, change.toString()));
              }
              requestId = v4();
              _context9.n = 24;
              return session.utxo.ghostKey(recipients, requestId, spendPrivateKey);
            case 24:
              ghosts = _context9.v;
              tx = buildSafeTransaction(utxos, recipients, ghosts, memoBytes(memo));
              raw = encodeSafeTransaction(tx);
              _context9.n = 25;
              return session.utxo.verifyTransaction([{
                raw: raw,
                request_id: requestId
              }]);
            case 25:
              txs = _context9.v;
              signedRaw = signSafeTransaction(tx, txs[0].views, spendPrivateKey);
              _context9.n = 26;
              return session.utxo.sendTransactions([{
                raw: signedRaw,
                request_id: requestId
              }]);
            case 26:
              sent = _context9.v;
              return _context9.a(2, {
                hash: (sent === null || sent === void 0 || (_sent$3 = sent[0]) === null || _sent$3 === void 0 ? void 0 : _sent$3.transaction_hash) || '',
                pendingBalance: pendingBalance(balance, amount, quote.amount)
              });
          }
        }, _callee9);
      }));
      function sendToAddress(_x17, _x18, _x19, _x20) {
        return _sendToAddress.apply(this, arguments);
      }
      return sendToAddress;
    }()
  }]);
}();
module.exports = Api;
module.exports.MIXIN_APP_KEY_FIELDS = MIXIN_APP_KEY_FIELDS;
module.exports.mixinAppKeystore = mixinAppKeystore;
module.exports.mixinAppKeystoreFromEnv = mixinAppKeystoreFromEnv;
module.exports.createAppSession = _createAppSession;
module.exports.createUserSession = createUserSession;
module.exports.getWithdrawalFeeQuote = getWithdrawalFeeQuote;
module.exports.formatMixinError = formatMixinError;